<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'meteringpoint.identification' | translate }}</label>
    <input appInput formControlName="meteringPointIdentification" readonly>
  </app-input-group>
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.start' | translate }}</label>
    <input type="date" appInput formControlName="start">
  </app-input-group>
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.end' | translate }}</label>
    <input type="date" appInput formControlName="end">
  </app-input-group>
</form>
